<template>
    <VJoyTemplate full sidebar="right">
        <template #template-main>
            <VJoyTemplate full sidebar="left">
                <template #template-main>
                    <h2 class="data-protection-policy__title">{{ page.data.title }}</h2>
                    <PrismicRichText :field="page.data.content" />
                </template>
                <template #template-sidebar>
                    <Sidebar current-link="data-protection-policy" />
                </template>
            </VJoyTemplate>
        </template>
    </VJoyTemplate>
</template>

<script setup lang="ts">
    import type {PrismicDocument} from '@prismicio/types';
    import {PrismicRichText} from '@prismicio/vue';
    import {
        createError,
        definePageMeta,
        ref,
        useAsyncData,
        useSeoMeta,
        useTranslation,
        OpenGraphMetaTag,
        TwitterMetaTags,
        useOpenGraphMetaTags,
        useTwitterMetaTags,
    } from '#imports';
    import {VJoyTemplate} from '@maltjoy/core-vue';
    import Sidebar from '~/components/content/Sidebar.vue';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';

    definePageMeta({
        layout: 'content',
    });

    const {t} = useTranslation();

    const page = ref();

    const {fetchDocument} = usePrismicDocument('candidatePrivacyPolicy');

    const {data, error} = await useAsyncData<PrismicDocument>('candidate-privacy-policy', () => fetchDocument(), {deep: true});
    if (error.value) {
        throw createError(error.value);
    }
    page.value = data.value;

    useTwitterMetaTags(
        new TwitterMetaTags({
            card: 'summary',
            title: t('gdpr.title.data.protection.policy'),
            description: t('gdpr.meta.desc.data.protection.policy'),
            t,
        }),
    );
    useOpenGraphMetaTags(
        new OpenGraphMetaTag({
            title: t('gdpr.title.data.protection.policy'),
            description: t('gdpr.meta.desc.data.protection.policy'),
            t,
        }),
    );

    useSeoMeta({
        title: t('gdpr.title.data.protection.policy'),
        description: t('gdpr.meta.desc.data.protection.policy'),
    });
</script>

<style lang="scss">
    .data-protection-policy {
        &__title {
            font-size: var(--joy-font-size-secondary-200);
            margin-bottom: var(--joy-core-spacing-8);
        }
    }
</style>
